export const figure8 = {
chart: {
type: 'column',
	spacingBottom: 40,

	backgroundColor: 'rgba(255, 255, 255, 0.0)',
	scrollablePlotArea: {
		minWidth: 1650,
		scrollPositionX: 1,
	},
},
	scrollbar: {
		enabled: true
	},
title: {
text: ''
},
exporting: {
enabled: false
},
credits: {
enabled: false
},
xAxis: {
categories: ['Monde', 'Asie centrale et Asie du Sud', 'Asie de l’Est et Asie du Sud-Est', 'Amérique latine et Caraïbes', 'Amérique du Nord et Europe', 'Océanie', 'Afrique subsaharienne', 'Asie de l’Ouest et Afrique du Nord'],
labels: {
	groupedOptions: [{
	}, {
	}],
	rotation: 0, // 0-level options aren't changed, use them as always
y: 40,
style: {
	   textOverflow: 'none',

},
	    }
},
yAxis: {
allowDecimals: false,
min: 0,
max: 80,
tickInterval: 10,
title: {
text: 'Pourcentage',

},
stackLabels: {
enabled: true,
verticalAlign: 'bottom',
crop: false,
	overflow: 'none',
y: 20,
formatter: function () {
	       return this.stack;
       },
       style: {
	       fontSize: '8px',
	       fontWeight: 'normal',
	       color: '#333'

       }
}
},
legend: {
enabled: false,
},
tooltip: {
formatter: function () {
		   var y_value = (this.y / 1).toString().replace('.', ',');
		   return this.series.userOptions.stack + ', ' + this.x + '<br/>'+ this.series.name + '' + ': <b>' + y_value + '%</b>';
},

},
plotOptions: {
column: {
stacking: 'normal',

}
},



series: [{
name: 'Insécurité alimentaire grave',
color: '#C22E0C',
data: [12.8, 20.9, 1.9, 14.4, 1.2, 2.3, 27.6, 9.8],
stack: 'Rurale',
index: 2,
	pointWidth: 12

},
{
name: 'Insécurité alimentaire grave',
color: '#C22E0C',
data: [11.6, 19.7, 1.6, 12.6, 1.3, 3.4, 26.3, 10.0],
// showInLegend: false,
stack: 'Périurbaine',
linkedTo: ':previous',
index: 2,
		pointWidth: 12

	},
{
name: 'Insécurité alimentaire grave',
color: '#C22E0C',
data: [9.4, 17.1, 1.0, 10.1, 1.4, 2.6, 23.0, 11.0],
// showInLegend: false,
stack: 'Urbaine',
linkedTo: ':previous',
      index: 2,
		pointWidth: 12

	},
{
name: 'Insécurité alimentaire modérée',
color: '#F39200',
data: [20.5, 20.3, 11.4, 26.0, 5.6, 7.3, 40.5, 24.1],
stack: 'Rurale',
index: 1,
	pointWidth: 12

}, {
name: 'Insécurité alimentaire modérée',
data: [17.2, 19.9, 6.6, 26.0, 5.2, 10.2, 42.0, 22.7],
color: '#F39200',
// showInLegend: false,
linkedTo: ':previous',
stack: 'Périurbaine',
      index: 1,
		pointWidth: 12

	},
{
name: 'Insécurité alimentaire modérée',
data: [16.6, 21.0, 6.1, 22.1, 6.1, 8.5, 39.5, 20.6],
color: '#F39200',
// showInLegend: false,
linkedTo: ':previous',
stack: 'Urbaine',
      index: 1,
		pointWidth: 12

	},
]
};